module.exports = __webpack_public_path__ + "static/media/cryActive.3a7386bd.png";